import React from 'react';
import { Check, X } from 'lucide-react';
import { translate } from '../../../lib/translations';

interface TradeActionsProps {
  onAccept: () => void;
  onReject: () => void;
  processing: boolean;
  language: 'en' | 'fr';
}

export function TradeActions({
  onAccept,
  onReject,
  processing,
  language,
}: TradeActionsProps) {
  const handleAccept = () => {
    if (processing) return;
    onAccept();
  };

  const handleReject = () => {
    if (processing) return;
    onReject();
  };

  return (
    <div className="d-flex justify-content-end gap-2 mt-4">
      <button
        className="btn btn-success d-flex align-items-center"
        onClick={handleAccept}
        disabled={processing}
        style={{ 
          minWidth: '120px',
          cursor: processing ? 'not-allowed' : 'pointer'
        }}
      >
        {processing ? (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <Check size={18} className="me-2" />
        )}
        {processing ? translate('processing', language) : translate('approve', language)}
      </button>
      <button
        className="btn btn-danger d-flex align-items-center"
        onClick={handleReject}
        disabled={processing}
        style={{ 
          minWidth: '120px',
          cursor: processing ? 'not-allowed' : 'pointer'
        }}
      >
        {processing ? (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <X size={18} className="me-2" />
        )}
        {processing ? translate('processing', language) : translate('reject', language)}
      </button>
    </div>
  );
}